import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Nav from "./Nav";
import { EventDiscordLinks } from "./EventDiscordLinks";

const NAV_LINKS = [
  { label: "Home", href: "/", external: false },
  { label: "Hierarchy", href: "/hierarchy", external: false },
  { label: "Events", href: "/events", external: false },
];

const ACCENT = "#ce93d8";

const MEMBER_GROUPS = [
  {
    label: "Executive Officers",
    color: "#facc15",
    members: [
      { name: "SpartanBoy45", role: "Captain", avatar: "https://cdn.discordapp.com/avatars/742775269516902511/a_a7e8a45c4f9d13820ecac576517a7b63.gif", href: "https://starkeeper.industries/members/203" },
      { name: "DarkDemonWolfx", role: "Executive Officer", avatar: "https://cdn.discordapp.com/avatars/350586608426156032/5879286c5447fbaaea029733142a66db.png", href: "https://starkeeper.industries/members/183" },
      { name: "Vacant", role: "Logistics Commander", avatar: null, href: null },
      { name: "Vacant", role: "Pilot", avatar: null, href: null },
    ],
  },
  {
    label: "Red Team",
    color: "#ff4444",
    members: [
      { name: "Unknown_Error", role: "Lt. Commander", avatar: "https://cdn.discordapp.com/avatars/187/8310028adaa026f785700c50813ebc66.png", href: "https://starkeeper.industries/members/187" },
      { name: "nka", role: "Medical | Engineering Specialist", avatar: "https://cdn.discordapp.com/avatars/153/7a3ae53f1d96be3c391557658510ed5b.png", href: "https://starkeeper.industries/members/153" },
      { name: "Tdeuce22", role: "Crew", avatar: "https://cdn.discordapp.com/avatars/148/db55c27502c204f82ab25b150f771947.png", href: "https://starkeeper.industries/members/148" },
      { name: "Vacant", role: "Medical | Engineering Specialist", avatar: null, href: null },
      { name: "Vacant", role: "Crew x6", avatar: null, href: null },
    ],
  },
  {
    label: "Purple Team",
    color: "#b060e0",
    members: [
      { name: "Cr0sshairs", role: "Lt. Commander", avatar: "https://cdn.discordapp.com/avatars/193/447d4b8ca79f13e7f3e681e8a31b4d2a.png", href: "https://starkeeper.industries/members/193" },
      { name: "MilkieMoo (Moonugget)", role: "Medical Specialist", avatar: "https://cdn.discordapp.com/avatars/178/33fa814b1d9cbf98bb87235c5a9964c2.png", href: "https://starkeeper.industries/members/178" },
      { name: "Zeke", role: "Crew", avatar: "https://cdn.discordapp.com/avatars/149/ee890f1830b60db59e415e72b93b8c65.png", href: "https://starkeeper.industries/members/149" },
      { name: "Warthog", role: "Crew", avatar: "https://cdn.discordapp.com/avatars/167/190751505da37b1ac3cba383b8d71171.png", href: "https://starkeeper.industries/members/167" },
      { name: "WYLDE", role: "Crew", avatar: "https://cdn.discordapp.com/avatars/266/a89c56e18705b99f1dc8d3226ccc0df0.png", href: "https://starkeeper.industries/members/266" },
      { name: "Vacant", role: "Engineering Specialist", avatar: null, href: null },
      { name: "Vacant", role: "Crew x4", avatar: null, href: null },
    ],
  },
  {
    label: "Recruiting",
    color: "#00fffb",
    members: [
      { name: "Vacant", role: "Lt. Commander", avatar: null, href: null },
      { name: "Vacant", role: "Engineering Specialist", avatar: null, href: null },
      { name: "Vacant", role: "Medical Specialist", avatar: null, href: null },
      { name: "Vacant", role: "Crew x7", avatar: null, href: null },
    ],
  },
];

const FLEET = [
  "350r", "600i Touring", "890 Jump", "ATLS", "ATLS GEO", "Apollo Medivac",
  "Ares Inferno", "Ares Ion", "Arrastra", "Arrow", "Asgard", "Aurora MR",
  "Avenger Stalker", "Avenger Titan", "Avenger Warlock", "Ballista", "Blade",
  "C2 Hercules", "C8 Pisces", "Carrack", "Caterpillar Best In Show 2949",
  "Centurion", "Clipper", "Constellation Andromeda", "Constellation Aquila",
  "Constellation Phoenix", "Constellation Phoenix Emerald", "Corsair",
  "Crucible", "Cutlass Red", "Cutlass Steel", "Cutter",
];

const HOME_BASES = [
  { label: "Undisclosed", count: 8, total: 10, color: "#60a5fa" },
  { label: "Levski", count: 2, total: 10, color: "#34d399" },
];

const AVAILABILITY = [
  {
    name: "SpartanBoy45",
    timezone: "America/New_York",
    color: { bg: "rgba(96,165,250,0.55)", border: "rgba(96,165,250,0.85)" },
    window: {
      sunday:    { start: 21, end: 23 },
      monday:    { start: 21, end: 23 },
      tuesday:   { start: 21, end: 23 },
      wednesday: { start: 21, end: 23 },
      thursday:  { start: 21, end: 23 },
      friday:    { start: 21, end: 23 },
      saturday:  { start: 21, end: 23 },
    },
  },
  {
    name: "DarkDemonWolfx",
    timezone: "America/Chicago",
    color: { bg: "rgba(52,211,153,0.55)", border: "rgba(52,211,153,0.85)" },
    window: {
      sunday:    { start: 3,  end: 17,  all_day: false },
      monday:    { start: 14, end: 19 },
      tuesday:   { start: 16, end: 19 },
      wednesday: { start: 18, end: 19 },
      thursday:  { start: 15, end: 18 },
      friday:    { start: 14, end: 23 },
      saturday:  { start: 0,  end: 23, all_day: true },
    },
  },
];

const DAYS = ["sunday","monday","tuesday","wednesday","thursday","friday","saturday"];
const DAY_LABELS = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];

function getOffsetHours(tz) {
  try {
    const date = new Date();
    const parts = new Intl.DateTimeFormat("en-US", { timeZone: tz, year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric", second: "numeric", hour12: false }).formatToParts(date);
    const p = {};
    parts.forEach(part => { p[part.type] = parseInt(part.value, 10); });
    const tzMs = Date.UTC(p.year, p.month - 1, p.day, p.hour === 24 ? 0 : p.hour, p.minute, p.second);
    return Math.round((tzMs - date.getTime()) / 3600000 * 4) / 4;
  } catch { return 0; }
}

function fmtHour(h) {
  h = Math.round(((h % 24) + 24) % 24);
  if (h === 0 || h === 24) return "12 am";
  if (h === 12) return "12 pm";
  return h < 12 ? `${h} am` : `${h - 12} pm`;
}

const OPERATIONS = [
  { label: "Exploration", color: "#4fc3f7", icon: "🌌" },
  { label: "Mining", color: "#fcd657", icon: "⛏" },
  { label: "Transport", color: "#81c784", icon: "📦" },
  { label: "Salvage", color: "#ce93d8", icon: "🔩" },
  { label: "Piracy", color: "#ef5350", icon: "☠" },
  { label: "Combat", color: "#ff7043", icon: "💥" },
];

// ── Shared ─────────────────────────────────────────────────────────────────────

function StarField() {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let animId;
    const stars = Array.from({ length: 350 }, () => ({
      x: Math.random(), y: Math.random(),
      r: Math.random() * 1.8 + 0.3,
      a: Math.random(), speed: Math.random() * 0.004 + 0.001,
    }));
    const resize = () => { canvas.width = window.innerWidth; canvas.height = window.innerHeight; };
    resize();
    window.addEventListener("resize", resize);
    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      stars.forEach((s) => {
        s.a += s.speed;
        if (s.a > 1) s.a = 0;
        const alpha = Math.sin(s.a * Math.PI) * 0.85 + 0.15;
        ctx.beginPath();
        ctx.arc(s.x * canvas.width, s.y * canvas.height, s.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255,255,255,${alpha})`;
        ctx.fill();
      });
      animId = requestAnimationFrame(draw);
    };
    draw();
    return () => { cancelAnimationFrame(animId); window.removeEventListener("resize", resize); };
  }, []);
  return <canvas ref={canvasRef} style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100vh", pointerEvents: "none", zIndex: 0 }} />;
}

function useScrollReveal() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setVisible(true); obs.disconnect(); } }, { threshold: 0.08 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return [ref, visible];
}

function Reveal({ children, delay = 0, style = {} }) {
  const [ref, visible] = useScrollReveal();
  return (
    <div ref={ref} style={{ opacity: visible ? 1 : 0, transform: visible ? "translateY(0)" : "translateY(28px)", transition: `opacity 0.6s ease ${delay}s, transform 0.6s ease ${delay}s`, ...style }}>
      {children}
    </div>
  );
}

function SectionLabel({ children, color = ACCENT }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 12 }}>
      <div style={{ width: 40, height: 2, background: color, flexShrink: 0 }} />
      <span style={{ fontFamily: "'Space Mono', monospace", fontSize: 10, letterSpacing: 4, color, textTransform: "uppercase" }}>{children}</span>
    </div>
  );
}

function Avatar({ src, name, size = 40 }) {
  const [err, setErr] = useState(false);
  const isVacant = name === "Vacant";
  return (
    <div style={{ width: size, height: size, borderRadius: "50%", overflow: "hidden", flexShrink: 0, background: "#0d1120", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid rgba(255,255,255,0.1)" }}>
      {src && !err && !isVacant
        ? <img src={src} alt={name} onError={() => setErr(true)} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        : <span style={{ fontFamily: "'Orbitron'", fontSize: size * 0.38, color: "rgba(255,255,255,0.25)", fontWeight: 700 }}>{isVacant ? "?" : name.charAt(0)}</span>
      }
    </div>
  );
}

// ── Page ───────────────────────────────────────────────────────────────────────

export default function SovereignRevenantPage() {
  const [activeTab, setActiveTab] = useState("members");
  const [barsVisible, setBarsVisible] = useState(false);
  const [showEventForm, setShowEventForm] = useState(false);
  const [events, setEvents] = useState([
    {
      id: 1, title: "Large Scale Mining Op", type: "Industry", date: "2926-04-05", time: "20:00",
      description: "Full org mining deployment around Yela's asteroid belt. All mining ships required. Bring prospectors and ROCs. Ore quotas will be assigned per ship.",
      image: "https://robertsspaceindustries.com/media/b9ka4ohfxyb1kr/source/StarCitizen_Square.jpg",
      allowSharing: true, reminder: "discord",
      tags: ["Mining", "Industry", "All Hands"],
    },
    {
      id: 2, title: "Salvage Run — Derelict Idris", type: "Salvage", date: "2926-04-08", time: "21:00",
      description: "Intel confirms a derelict Idris near Microtech orbit. TSR is moving in to strip it before the Levski scrappers get there. Hull-D and Reclaimer crews report to hangar bay 3.",
      image: "https://robertsspaceindustries.com/media/b9ka4ohfxyb1kr/source/StarCitizen_Square.jpg",
      allowSharing: false, reminder: "email",
      tags: ["Salvage", "Priority", "Capital"],
    },
    {
      id: 3, title: "Defend Your Station", type: "Combat", date: "2926-04-12", time: "19:30",
      description: "Hostile org detected probing our Lagrange point outpost. Security division deploys in full force. Fighters scramble on contact. Bridgeguard holds the interior. All hands battle stations.",
      image: "https://robertsspaceindustries.com/media/b9ka4ohfxyb1kr/source/StarCitizen_Square.jpg",
      allowSharing: true, reminder: "both",
      tags: ["Combat", "Defense", "All Hands"],
    },
    {
      id: 4, title: "Engineering Challenge", type: "Training", date: "2926-04-15", time: "18:00",
      description: "Weekly engineering drill aboard the Idris. Damage control scenarios, power management under fire, and repair speed trials. Top engineers earn commendation badges.",
      image: "https://robertsspaceindustries.com/media/b9ka4ohfxyb1kr/source/StarCitizen_Square.jpg",
      allowSharing: false, reminder: "discord",
      tags: ["Training", "Engineering", "Crew"],
    },
    {
      id: 5, title: "Piracy Sweep — Pyro Gate", type: "Piracy", date: "2926-04-19", time: "22:00",
      description: "TSR moves through the Pyro jump gate corridor to intercept unaffiliated haulers. All combat-rated crew aboard. Logistics support on standby for cargo offload.",
      image: "https://robertsspaceindustries.com/media/b9ka4ohfxyb1kr/source/StarCitizen_Square.jpg",
      allowSharing: true, reminder: "none",
      tags: ["Piracy", "Combat", "Crew"],
    },
  ]);
  const [newEvent, setNewEvent] = useState({
    title: "", type: "Combat", date: "", time: "", description: "",
    image: "", allowSharing: false, reminder: "discord", tags: "",
  });
  const [shareToast, setShareToast] = useState(null);
  const homesRef = useRef(null);

  useEffect(() => {
    if (activeTab !== "homes") return;
    const timer = setTimeout(() => setBarsVisible(true), 100);
    return () => clearTimeout(timer);
  }, [activeTab]);

  const TABS = [
    { id: "members", label: "Team Members", color: ACCENT },
    { id: "fleet", label: "Team Fleet", color: "#a78bfa" },
    { id: "homes", label: "Home Bases", color: "#34d399" },
    { id: "availability", label: "Team Availability", color: "#f59e0b" },
    { id: "events", label: "Events", color: "#f87171" },
  ];

  return (
    <div style={{ fontFamily: "'Rajdhani', 'Orbitron', sans-serif", background: "#05070f", color: "#e8eaf6", minHeight: "100vh", overflowX: "hidden" }}>
      <StarField />

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@300;400;500;600;700&family=Orbitron:wght@400;600;700;900&family=Space+Mono&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::selection { background: #ce93d8; color: #05070f; }
        a { text-decoration: none; color: inherit; }
        .nav-link { font-family: 'Orbitron', sans-serif; font-size: 11px; letter-spacing: 2.5px; text-transform: uppercase; color: rgba(232,234,246,0.55); transition: color 0.2s; padding: 4px 0; position: relative; }
        .nav-link::after { content: ''; position: absolute; bottom: 0; left: 0; width: 0; height: 1px; background: #ce93d8; transition: width 0.3s ease; }
        .nav-link:hover { color: #ce93d8; }
        .nav-link:hover::after { width: 100%; }
        .glow-btn { display: inline-block; padding: 12px 32px; border: 2px solid #ce93d8; color: #ce93d8; font-family: 'Orbitron', sans-serif; font-size: 12px; font-weight: 700; letter-spacing: 3px; text-transform: uppercase; cursor: pointer; background: transparent; transition: all 0.3s ease; clip-path: polygon(12px 0%, 100% 0%, calc(100% - 12px) 100%, 0% 100%); }
        .glow-btn:hover { background: #ce93d8; color: #05070f; box-shadow: 0 0 40px rgba(206,147,216,0.4); }
        .scanline { position: fixed; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; z-index: 9999; background: repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0,0,0,0.03) 2px, rgba(0,0,0,0.03) 4px); }
        @keyframes floatUp { from { opacity: 0; transform: translateY(50px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.3; } }
        @keyframes shimmer { 0% { background-position: -200% center; } 100% { background-position: 200% center; } }
      `}</style>

      <div className="scanline" />

      <Nav accentColor="#ce93d8" />

      {/* HERO */}
      <section style={{ position: "relative", minHeight: "72vh", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", padding: "120px 40px 80px" }}>
        <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)", width: 800, height: 800, background: "radial-gradient(circle, rgba(156,100,166,0.1) 0%, transparent 70%)", pointerEvents: "none", zIndex: 1 }} />
        <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)", width: 600, height: 600, backgroundImage: "url(https://starkeeper.industries/storage/team-images/01KJWM2B761W51KNBP5RCWYY3F.png)", backgroundSize: "contain", backgroundRepeat: "no-repeat", backgroundPosition: "center", opacity: 0.05, zIndex: 1, pointerEvents: "none" }} />

        <div style={{ position: "relative", zIndex: 2, maxWidth: 860, width: "100%", textAlign: "center" }}>
          <div style={{ opacity: 0, animation: "floatUp 0.6s ease forwards 0.2s", display: "flex", alignItems: "center", justifyContent: "center", gap: 12, marginBottom: 28 }}>
            <Link to="/hierarchy" style={{ fontFamily: "'Space Mono', monospace", fontSize: 10, letterSpacing: 4, color: "rgba(206,147,216,0.6)", transition: "color 0.2s" }}
              onMouseEnter={e => e.target.style.color = ACCENT} onMouseLeave={e => e.target.style.color = "rgba(206,147,216,0.6)"}>SECURITY DIVISION</Link>
            <span style={{ color: "rgba(255,255,255,0.2)" }}>◆</span>
            <span style={{ fontFamily: "'Space Mono', monospace", fontSize: 10, letterSpacing: 4, color: ACCENT }}>TEAM</span>
          </div>

          <div style={{ width: 220, height: 220, margin: "0 auto 36px", opacity: 0, animation: "floatUp 0.7s ease forwards 0.3s" }}>
            <img src="https://starkeeper.industries/storage/team-images/01KJWM2B761W51KNBP5RCWYY3F.png" alt="TSR patch" style={{ width: "100%", height: "100%", objectFit: "contain" }} onError={(e) => { e.target.style.display = "none"; }} />
          </div>

          <div style={{ opacity: 0, animation: "floatUp 0.7s ease forwards 0.4s" }}>
            <div style={{ fontFamily: "'Space Mono', monospace", fontSize: 9, letterSpacing: 5, color: ACCENT, marginBottom: 10 }}>The</div>
            <h1 style={{ fontFamily: "'Orbitron', sans-serif", fontWeight: 900, fontSize: "clamp(38px, 8vw, 96px)", lineHeight: 0.88, color: "#e8eaf6", marginBottom: 8 }}>SOVEREIGN</h1>
            <h1 style={{ fontFamily: "'Orbitron', sans-serif", fontWeight: 900, fontSize: "clamp(38px, 8vw, 96px)", lineHeight: 0.88, marginBottom: 32, background: `linear-gradient(90deg, ${ACCENT}, #e040fb, ${ACCENT})`, backgroundSize: "200% auto", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", animation: "shimmer 4s linear infinite" }}>REVENANT</h1>
          </div>

          <p style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: "clamp(16px, 2vw, 22px)", fontWeight: 600, color: "rgba(232,234,246,0.65)", lineHeight: 1.6, opacity: 0, animation: "floatUp 0.7s ease forwards 0.55s" }}>
            The ship is our platform. The crew is our strength.<br />
            <span style={{ color: ACCENT }}>The mission evolves.</span>
          </p>

          <div style={{ display: "flex", gap: 16, justifyContent: "center", flexWrap: "wrap", marginTop: 36, opacity: 0, animation: "floatUp 0.7s ease forwards 0.7s" }}>
            <a href="https://discord.gg/aEPQ6Zfvhd" className="glow-btn">Join the Crew</a>
            <Link to="/hierarchy" style={{ display: "inline-block", padding: "12px 32px", border: "2px solid rgba(255,255,255,0.18)", color: "rgba(232,234,246,0.55)", fontFamily: "'Orbitron', sans-serif", fontSize: 12, fontWeight: 700, letterSpacing: 3, textTransform: "uppercase", transition: "all 0.3s ease", clipPath: "polygon(12px 0%, 100% 0%, calc(100% - 12px) 100%, 0% 100%)" }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = "rgba(255,255,255,0.45)"; e.currentTarget.style.color = "#e8eaf6"; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = "rgba(255,255,255,0.18)"; e.currentTarget.style.color = "rgba(232,234,246,0.55)"; }}>
              All Teams
            </Link>
          </div>
        </div>

        <div style={{ position: "absolute", bottom: 32, left: "50%", transform: "translateX(-50%)", zIndex: 2, display: "flex", flexDirection: "column", alignItems: "center", gap: 8, opacity: 0, animation: "floatUp 0.6s ease forwards 1.1s" }}>
          <span style={{ fontFamily: "'Space Mono'", fontSize: 9, letterSpacing: 3, color: "rgba(255,255,255,0.22)" }}>SCROLL</span>
          <div style={{ width: 1, height: 36, background: `linear-gradient(to bottom, ${ACCENT}77, transparent)`, animation: "pulse 2s infinite" }} />
        </div>
      </section>

      {/* ABOUT */}
      <section style={{ position: "relative", zIndex: 1, borderTop: "1px solid rgba(206,147,216,0.12)", background: "rgba(18,9,24,0.55)", padding: "80px 40px" }}>
        <div style={{ maxWidth: 1000, margin: "0 auto" }}>
          <Reveal>
            <SectionLabel>About TSR</SectionLabel>
            <h2 style={{ fontFamily: "'Orbitron', sans-serif", fontWeight: 700, fontSize: "clamp(22px, 4vw, 44px)", color: "#e8eaf6", marginBottom: 32, lineHeight: 1.1 }}>
              A Capital-Class Crew<br /><span style={{ color: ACCENT }}>Built Around the Idris</span>
            </h2>
          </Reveal>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 40 }}>
            <Reveal delay={0.1}>
              <p style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 17, color: "rgba(232,234,246,0.62)", lineHeight: 1.9 }}>
                The Sovereign Revenant is a capital-class crew built around the Idris as both warship and home. We operate as a unified division — exploring, mining, transporting, salvaging, and engaging in piracy when the opportunities arise. Adaptability defines us.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <p style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 17, color: "rgba(232,234,246,0.62)", lineHeight: 1.9 }}>
                Every member is vital. No one is confined to a single seat unless they choose to master it. We train across disciplines to remain capable, engaged, and resilient. In large-scale org operations, TSR deploys as a strategic capital asset — the Idris as a force multiplier integrating directly with command.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      {/* OPERATIONS */}
      <section style={{ position: "relative", zIndex: 1, padding: "80px 40px" }}>
        <div style={{ maxWidth: 1000, margin: "0 auto" }}>
          <Reveal>
            <SectionLabel>Mission Profile</SectionLabel>
            <h2 style={{ fontFamily: "'Orbitron', sans-serif", fontWeight: 700, fontSize: "clamp(22px, 4vw, 40px)", color: "#e8eaf6", marginBottom: 40 }}>What We Do</h2>
          </Reveal>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: 14 }}>
            {OPERATIONS.map((op, i) => (
              <Reveal key={op.label} delay={i * 0.07}>
                <div style={{ padding: "24px 16px", textAlign: "center", border: `1px solid ${op.color}33`, background: `${op.color}08`, clipPath: "polygon(0 0, calc(100% - 12px) 0, 100% 12px, 100% 100%, 12px 100%, 0 calc(100% - 12px))", transition: "all 0.3s ease", cursor: "default" }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = `${op.color}77`; e.currentTarget.style.background = `${op.color}14`; e.currentTarget.style.boxShadow = `0 0 24px ${op.color}18`; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = `${op.color}33`; e.currentTarget.style.background = `${op.color}08`; e.currentTarget.style.boxShadow = "none"; }}>
                  <div style={{ fontSize: 28, marginBottom: 10 }}>{op.icon}</div>
                  <div style={{ fontFamily: "'Space Mono', monospace", fontSize: 9, letterSpacing: 2, color: op.color, textTransform: "uppercase" }}>{op.label}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* TABBED SECTION */}
      <section style={{ position: "relative", zIndex: 1, background: "rgba(18,9,24,0.5)", borderTop: "1px solid rgba(206,147,216,0.1)", borderBottom: "1px solid rgba(206,147,216,0.1)", paddingBottom: 80 }}>
        <div style={{ maxWidth: 1000, margin: "0 auto", padding: "0 40px" }}>

          {/* Tabs */}
          <div style={{ display: "flex", gap: 2, borderBottom: "1px solid rgba(255,255,255,0.08)", marginBottom: 48 }}>
            {TABS.map((tab) => (
              <button key={tab.id} onClick={() => setActiveTab(tab.id)} style={{ fontFamily: "'Orbitron', sans-serif", fontSize: 11, letterSpacing: 2, textTransform: "uppercase", padding: "16px 22px", border: "none", cursor: "pointer", background: activeTab === tab.id ? `${tab.color}12` : "transparent", color: activeTab === tab.id ? tab.color : "rgba(232,234,246,0.38)", borderBottom: activeTab === tab.id ? `2px solid ${tab.color}` : "2px solid transparent", transition: "all 0.2s ease" }}>
                {tab.label}
              </button>
            ))}
          </div>

          {/* MEMBERS */}
          {activeTab === "members" && (
            <div style={{ display: "flex", flexDirection: "column", gap: 44 }}>
              {MEMBER_GROUPS.map((group, gi) => (
                <Reveal key={group.label} delay={gi * 0.08}>
                  <div style={{ fontFamily: "'Space Mono', monospace", fontSize: 9, letterSpacing: 4, color: group.color, textTransform: "uppercase", marginBottom: 14 }}>{group.label}</div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                    {group.members.map((m, mi) => {
                      const isVacant = m.name === "Vacant";
                      return (
                        <div key={`${m.name}-${mi}`} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 14px", border: `1px solid ${group.color}${isVacant ? "22" : "44"}`, background: `${group.color}${isVacant ? "05" : "09"}`, borderRadius: 3, opacity: isVacant ? 0.5 : 1 }}>
                          <Avatar src={m.avatar} name={m.name} size={36} />
                          <div>
                            {m.href
                              ? <a href={m.href} style={{ fontFamily: "'Rajdhani', sans-serif", fontWeight: 600, fontSize: 15, color: "#e8eaf6", transition: "color 0.2s" }} onMouseEnter={e => e.target.style.color = ACCENT} onMouseLeave={e => e.target.style.color = "#e8eaf6"}>{m.name}</a>
                              : <span style={{ fontFamily: "'Rajdhani', sans-serif", fontWeight: 600, fontSize: 15, color: "rgba(232,234,246,0.35)", fontStyle: "italic" }}>{m.name}</span>
                            }
                            <div style={{ fontFamily: "'Space Mono', monospace", fontSize: 9, letterSpacing: 1, color: group.color, opacity: 0.8 }}>{m.role}</div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </Reveal>
              ))}
            </div>
          )}

          {/* FLEET */}
          {activeTab === "fleet" && (
            <Reveal>
              <p style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 16, color: "rgba(232,234,246,0.4)", marginBottom: 28 }}>
                {FLEET.length} ships registered to The Sovereign Revenant.
              </p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                {FLEET.map((ship) => (
                  <div key={ship} style={{ padding: "8px 16px", border: "1px solid rgba(167,139,250,0.22)", background: "rgba(167,139,250,0.05)", fontFamily: "'Space Mono', monospace", fontSize: 10, letterSpacing: 1.5, color: "rgba(232,234,246,0.6)", transition: "all 0.2s ease", cursor: "default" }}
                    onMouseEnter={e => { e.currentTarget.style.borderColor = "rgba(167,139,250,0.55)"; e.currentTarget.style.color = "#e8eaf6"; e.currentTarget.style.background = "rgba(167,139,250,0.1)"; }}
                    onMouseLeave={e => { e.currentTarget.style.borderColor = "rgba(167,139,250,0.22)"; e.currentTarget.style.color = "rgba(232,234,246,0.6)"; e.currentTarget.style.background = "rgba(167,139,250,0.05)"; }}>
                    {ship}
                  </div>
                ))}
              </div>
            </Reveal>
          )}

          {/* HOMES */}
          {activeTab === "homes" && (
            <Reveal>
              <p style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 16, color: "rgba(232,234,246,0.4)", marginBottom: 40 }}>
                Where TSR members call home across the verse.
              </p>
              <div style={{ display: "flex", flexDirection: "column", gap: 20, maxWidth: 500 }} ref={homesRef}>
                {HOME_BASES.map((h) => (
                  <div key={h.label}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
                      <span style={{ fontFamily: "'Orbitron', sans-serif", fontWeight: 700, fontSize: 13, color: h.color }}>{h.label}</span>
                      <span style={{ fontFamily: "'Space Mono', monospace", fontSize: 10, color: h.color }}>{h.count} <span style={{ color: "rgba(255,255,255,0.25)" }}>/ {h.total} members</span></span>
                    </div>
                    <div style={{ height: 10, background: "rgba(255,255,255,0.06)", borderRadius: 2, overflow: "hidden" }}>
                      <div style={{ height: "100%", width: barsVisible ? `${(h.count / h.total) * 100}%` : "0%", background: h.color, borderRadius: 2, transition: "width 1.2s ease", boxShadow: `0 0 12px ${h.color}55` }} />
                    </div>
                  </div>
                ))}
              </div>
            </Reveal>
          )}

          {/* AVAILABILITY */}
          {activeTab === "availability" && (
            <Reveal>
              {(() => {
                const viewerTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
                const viewerOffset = getOffsetHours(viewerTz);
                const HOUR_COUNT = 24;
                const CHART_HEIGHT = 480;
                const LABEL_WIDTH = 52;
                const COL_GAP = 6;
                const BAR_GAP = 3;

                // Build per-day, per-member windows in local time
                const memberWindows = AVAILABILITY.map((member) => {
                  const shift = viewerOffset - getOffsetHours(member.timezone);
                  return {
                    ...member,
                    days: DAYS.map((day) => {
                      const win = member.window[day];
                      if (!win) return null;
                      if (win.all_day) return { start: 0, end: 24 };
                      let start = ((win.start + shift) % 24 + 24) % 24;
                      let end   = ((win.end   + shift) % 24 + 24) % 24;
                      if (end <= start) end += 24;
                      // Clamp to 0-24
                      start = Math.min(start, 24);
                      end   = Math.min(end, 24);
                      return { start, end };
                    }),
                  };
                });

                const hourLabels = [0,2,4,6,8,10,12,14,16,18,20,22,24];

                return (
                  <>
                    <p style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 15, color: "rgba(232,234,246,0.4)", marginBottom: 24 }}>
                      Times shown in your local timezone: <span style={{ color: "#f59e0b" }}>{viewerTz}</span>
                    </p>

                    {/* Legend */}
                    <div style={{ display: "flex", gap: 24, marginBottom: 24, flexWrap: "wrap" }}>
                      {AVAILABILITY.map((m) => (
                        <div key={m.name} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <div style={{ width: 14, height: 14, borderRadius: 3, background: m.color.bg, border: `1px solid ${m.color.border}` }} />
                          <span style={{ fontFamily: "'Rajdhani', sans-serif", fontWeight: 600, fontSize: 14, color: "#e8eaf6" }}>{m.name}</span>
                        </div>
                      ))}
                    </div>

                    {/* Chart */}
                    <div style={{ overflowX: "auto" }}>
                      <div style={{ minWidth: 600, display: "flex", gap: 0 }}>

                        {/* Y-axis hour labels */}
                        <div style={{ width: LABEL_WIDTH, flexShrink: 0, height: CHART_HEIGHT, position: "relative" }}>
                          {hourLabels.map((h) => (
                            <div key={h} style={{
                              position: "absolute",
                              top: `${(h / 24) * 100}%`,
                              right: 8,
                              transform: "translateY(-50%)",
                              fontFamily: "'Space Mono', monospace",
                              fontSize: 9, color: "rgba(232,234,246,0.35)",
                              whiteSpace: "nowrap",
                            }}>{fmtHour(h)}</div>
                          ))}
                        </div>

                        {/* Day columns */}
                        <div style={{ flex: 1, display: "flex", gap: COL_GAP }}>
                          {DAYS.map((day, di) => (
                            <div key={day} style={{ flex: 1, display: "flex", flexDirection: "column", gap: 4 }}>
                              {/* Day label */}
                              <div style={{ fontFamily: "'Space Mono', monospace", fontSize: 9, letterSpacing: 1, color: "rgba(232,234,246,0.4)", textAlign: "center", textTransform: "uppercase", marginBottom: 6 }}>
                                {DAY_LABELS[di]}
                              </div>

                              {/* Bar area */}
                              <div style={{ position: "relative", height: CHART_HEIGHT, background: "rgba(255,255,255,0.02)", border: "1px solid rgba(255,255,255,0.06)", borderRadius: 4, overflow: "hidden", display: "flex", gap: BAR_GAP, padding: "0 3px" }}>
                                {/* Horizontal grid lines */}
                                {hourLabels.map((h) => (
                                  <div key={h} style={{ position: "absolute", top: `${(h / 24) * 100}%`, left: 0, right: 0, height: 1, background: "rgba(255,255,255,0.05)", pointerEvents: "none" }} />
                                ))}

                                {/* Member bars */}
                                {memberWindows.map((member) => {
                                  const win = member.days[di];
                                  if (!win) return (
                                    <div key={member.name} style={{ flex: 1, height: "100%" }} />
                                  );
                                  const topPct   = (win.start / 24) * 100;
                                  const heightPct = ((win.end - win.start) / 24) * 100;
                                  const label = win.start === 0 && win.end === 24
                                    ? "All day"
                                    : `${fmtHour(win.start)} – ${fmtHour(win.end)}`;
                                  return (
                                    <div key={member.name} style={{ flex: 1, position: "relative", height: "100%" }}>
                                      <div
                                        title={`${member.name}: ${label}`}
                                        style={{
                                          position: "absolute",
                                          top: `${topPct}%`,
                                          height: `${heightPct}%`,
                                          left: 0, right: 0,
                                          background: member.color.bg,
                                          border: `1px solid ${member.color.border}`,
                                          borderRadius: 3,
                                          transition: "opacity 0.2s",
                                          display: "flex", alignItems: "center", justifyContent: "center",
                                          overflow: "hidden",
                                          cursor: "default",
                                        }}
                                        onMouseEnter={e => e.currentTarget.style.opacity = "0.7"}
                                        onMouseLeave={e => e.currentTarget.style.opacity = "1"}
                                      >
                                        {heightPct > 10 && (
                                          <span style={{ fontFamily: "'Space Mono', monospace", fontSize: 7, color: "#fff", textAlign: "center", lineHeight: 1.4, padding: "2px", writingMode: heightPct < 20 ? "horizontal-tb" : "vertical-rl", transform: heightPct < 20 ? "none" : "rotate(180deg)" }}>
                                            {label}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </>
                );
              })()}
            </Reveal>
          )}

          {/* EVENTS */}
          {activeTab === "events" && (
            <div>
              {/* Toast */}
              {shareToast && (
                <div style={{ position: "fixed", bottom: 32, right: 32, zIndex: 9000, padding: "14px 24px", background: "rgba(18,9,24,0.97)", border: "1px solid #f87171", borderRadius: 4, fontFamily: "'Space Mono', monospace", fontSize: 11, color: "#f87171", letterSpacing: 1.5, boxShadow: "0 0 30px rgba(248,113,113,0.2)" }}>
                  {shareToast}
                </div>
              )}

              {/* Header row */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 36, flexWrap: "wrap", gap: 16 }}>
                <div>
                  <SectionLabel color="#f87171">Upcoming Operations</SectionLabel>
                  <h2 style={{ fontFamily: "'Orbitron', sans-serif", fontWeight: 700, fontSize: "clamp(20px, 3vw, 32px)", color: "#e8eaf6" }}>Mission Calendar</h2>
                </div>
                <button onClick={() => setShowEventForm(true)} style={{ fontFamily: "'Orbitron', sans-serif", fontSize: 11, fontWeight: 700, letterSpacing: 2.5, textTransform: "uppercase", padding: "12px 24px", border: "2px solid #f87171", color: "#f87171", background: "transparent", cursor: "pointer", transition: "all 0.3s ease", clipPath: "polygon(10px 0%, 100% 0%, calc(100% - 10px) 100%, 0% 100%)" }}
                  onMouseEnter={e => { e.currentTarget.style.background = "#f87171"; e.currentTarget.style.color = "#05070f"; }}
                  onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#f87171"; }}>
                  + Create Event
                </button>
              </div>

              {/* Event cards */}
              <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
                {events.sort((a, b) => new Date(`${a.date}T${a.time}`) - new Date(`${b.date}T${b.time}`)).map((ev, i) => {
                  const evDate = new Date(`${ev.date}T${ev.time}`);
                  const dayStr = evDate.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", year: "numeric" });
                  const timeStr = evDate.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
                  const typeColors = { Industry: "#fcd657", Salvage: "#a78bfa", Combat: "#ef5350", Training: "#4fc3f7", Piracy: "#f87171", Exploration: "#34d399" };
                  const typeColor = typeColors[ev.type] || "#ce93d8";
                  return (
                    <Reveal key={ev.id} delay={i * 0.07}>
                      <div style={{ display: "flex", border: "1px solid rgba(248,113,113,0.18)", background: "rgba(255,255,255,0.02)", overflow: "hidden", transition: "border-color 0.3s", clipPath: "polygon(0 0, calc(100% - 16px) 0, 100% 16px, 100% 100%, 0 100%)" }}
                        onMouseEnter={e => e.currentTarget.style.borderColor = "rgba(248,113,113,0.45)"}
                        onMouseLeave={e => e.currentTarget.style.borderColor = "rgba(248,113,113,0.18)"}>

                        {/* Date sidebar */}
                        <div style={{ width: 72, flexShrink: 0, background: `${typeColor}15`, borderRight: `2px solid ${typeColor}44`, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "16px 8px", textAlign: "center" }}>
                          <div style={{ fontFamily: "'Orbitron', sans-serif", fontWeight: 900, fontSize: 26, color: typeColor, lineHeight: 1 }}>{evDate.getDate()}</div>
                          <div style={{ fontFamily: "'Space Mono', monospace", fontSize: 8, color: typeColor, letterSpacing: 1, marginTop: 4 }}>{evDate.toLocaleDateString("en-US", { month: "short" }).toUpperCase()}</div>
                          <div style={{ fontFamily: "'Space Mono', monospace", fontSize: 8, color: "rgba(255,255,255,0.3)", marginTop: 2 }}>{evDate.getFullYear()}</div>
                        </div>

                        {/* Content */}
                        <div style={{ flex: 1, padding: "20px 24px", minWidth: 0 }}>
                          <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12, marginBottom: 8, flexWrap: "wrap" }}>
                            <div>
                              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6, flexWrap: "wrap" }}>
                                <span style={{ fontFamily: "'Space Mono', monospace", fontSize: 8, letterSpacing: 2, color: typeColor, textTransform: "uppercase", padding: "2px 8px", border: `1px solid ${typeColor}44`, background: `${typeColor}12` }}>{ev.type}</span>
                                {ev.tags.map(t => (
                                  <span key={t} style={{ fontFamily: "'Space Mono', monospace", fontSize: 8, letterSpacing: 1, color: "rgba(232,234,246,0.35)", padding: "2px 6px", border: "1px solid rgba(255,255,255,0.08)" }}>{t}</span>
                                ))}
                              </div>
                              <h3 style={{ fontFamily: "'Orbitron', sans-serif", fontWeight: 700, fontSize: "clamp(14px, 2vw, 18px)", color: "#e8eaf6", marginBottom: 4 }}>{ev.title}</h3>
                              <div style={{ fontFamily: "'Space Mono', monospace", fontSize: 9, color: "rgba(232,234,246,0.4)", letterSpacing: 1 }}>{dayStr} · {timeStr}</div>
                            </div>
                            {/* Action buttons */}
                            <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
                              {ev.allowSharing && (
                                <button onClick={() => {
                                  navigator.clipboard?.writeText(`TSR Event: ${ev.title} — ${dayStr} at ${timeStr}`).catch(() => {});
                                  setShareToast("Event link copied!");
                                  setTimeout(() => setShareToast(null), 2500);
                                }} style={{ fontFamily: "'Space Mono', monospace", fontSize: 8, letterSpacing: 1.5, padding: "6px 12px", border: "1px solid rgba(248,113,113,0.35)", color: "#f87171", background: "transparent", cursor: "pointer", textTransform: "uppercase", transition: "all 0.2s" }}
                                  onMouseEnter={e => { e.currentTarget.style.background = "rgba(248,113,113,0.1)"; }}
                                  onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}
                                  title="Share outside of team">
                                  ↗ Share
                                </button>
                              )}
                              {!ev.allowSharing && (
                                <span style={{ fontFamily: "'Space Mono', monospace", fontSize: 8, letterSpacing: 1, padding: "6px 10px", border: "1px solid rgba(255,255,255,0.08)", color: "rgba(255,255,255,0.2)", textTransform: "uppercase" }} title="External sharing disabled">🔒 Team Only</span>
                              )}
                            </div>
                          </div>
                          <p style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 15, color: "rgba(232,234,246,0.55)", lineHeight: 1.7, marginTop: 10 }}>{ev.description}</p>
                          {ev.reminder !== "none" && (
                            <div style={{ marginTop: 12, fontFamily: "'Space Mono', monospace", fontSize: 8, color: "rgba(232,234,246,0.25)", letterSpacing: 1 }}>
                              🔔 Reminder: {ev.reminder === "both" ? "Discord + Email" : ev.reminder === "discord" ? "Discord" : "Email"}
                            </div>
                          )}
                          <div style={{ marginTop: 12 }}>
                            <EventDiscordLinks eventId={ev.id} compact />
                          </div>
                        </div>
                      </div>
                    </Reveal>
                  );
                })}
              </div>

              {/* CREATE EVENT MODAL */}
              {showEventForm && (
                <div style={{ position: "fixed", inset: 0, zIndex: 2000, background: "rgba(0,0,0,0.85)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}
                  onClick={(e) => { if (e.target === e.currentTarget) setShowEventForm(false); }}>
                  <div style={{ width: "100%", maxWidth: 600, maxHeight: "90vh", overflowY: "auto", background: "#0a0610", border: "1px solid rgba(248,113,113,0.35)", padding: "36px 32px", position: "relative", clipPath: "polygon(0 0, calc(100% - 20px) 0, 100% 20px, 100% 100%, 0 100%)" }}>
                    {/* Corner accents */}
                    <div style={{ position: "absolute", top: 0, left: 0, width: 24, height: 24, borderTop: "2px solid #f87171", borderLeft: "2px solid #f87171" }} />
                    <div style={{ position: "absolute", bottom: 0, right: 0, width: 24, height: 24, borderBottom: "2px solid #f87171", borderRight: "2px solid #f87171" }} />

                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 28 }}>
                      <h3 style={{ fontFamily: "'Orbitron', sans-serif", fontWeight: 700, fontSize: 18, color: "#e8eaf6" }}>Create New Event</h3>
                      <button onClick={() => setShowEventForm(false)} style={{ background: "none", border: "none", color: "rgba(255,255,255,0.4)", fontSize: 20, cursor: "pointer", lineHeight: 1 }}>✕</button>
                    </div>

                    {/* Form fields */}
                    {[
                      { label: "Event Name", key: "title", type: "text", placeholder: "e.g. Salvage Run — Derelict Idris" },
                      { label: "Date", key: "date", type: "date", placeholder: "" },
                      { label: "Time", key: "time", type: "time", placeholder: "" },
                      { label: "Image URL", key: "image", type: "text", placeholder: "https://... (optional)" },
                    ].map(({ label, key, type, placeholder }) => (
                      <div key={key} style={{ marginBottom: 18 }}>
                        <label style={{ fontFamily: "'Space Mono', monospace", fontSize: 9, letterSpacing: 2, color: "#f87171", textTransform: "uppercase", display: "block", marginBottom: 8 }}>{label}</label>
                        <input type={type} placeholder={placeholder} value={newEvent[key]} onChange={e => setNewEvent(p => ({ ...p, [key]: e.target.value }))}
                          style={{ width: "100%", padding: "10px 14px", background: "rgba(255,255,255,0.04)", border: "1px solid rgba(248,113,113,0.25)", color: "#e8eaf6", fontFamily: "'Rajdhani', sans-serif", fontSize: 15, outline: "none", borderRadius: 2, colorScheme: "dark" }} />
                      </div>
                    ))}

                    {/* Type */}
                    <div style={{ marginBottom: 18 }}>
                      <label style={{ fontFamily: "'Space Mono', monospace", fontSize: 9, letterSpacing: 2, color: "#f87171", textTransform: "uppercase", display: "block", marginBottom: 8 }}>Event Type</label>
                      <select value={newEvent.type} onChange={e => setNewEvent(p => ({ ...p, type: e.target.value }))}
                        style={{ width: "100%", padding: "10px 14px", background: "#0a0610", border: "1px solid rgba(248,113,113,0.25)", color: "#e8eaf6", fontFamily: "'Rajdhani', sans-serif", fontSize: 15, outline: "none", borderRadius: 2 }}>
                        {["Combat", "Industry", "Salvage", "Training", "Piracy", "Exploration", "Other"].map(t => <option key={t} value={t}>{t}</option>)}
                      </select>
                    </div>

                    {/* Description */}
                    <div style={{ marginBottom: 18 }}>
                      <label style={{ fontFamily: "'Space Mono', monospace", fontSize: 9, letterSpacing: 2, color: "#f87171", textTransform: "uppercase", display: "block", marginBottom: 8 }}>Description</label>
                      <textarea rows={4} placeholder="Briefing, objectives, requirements..." value={newEvent.description} onChange={e => setNewEvent(p => ({ ...p, description: e.target.value }))}
                        style={{ width: "100%", padding: "10px 14px", background: "rgba(255,255,255,0.04)", border: "1px solid rgba(248,113,113,0.25)", color: "#e8eaf6", fontFamily: "'Rajdhani', sans-serif", fontSize: 15, outline: "none", borderRadius: 2, resize: "vertical" }} />
                    </div>

                    {/* Tags */}
                    <div style={{ marginBottom: 18 }}>
                      <label style={{ fontFamily: "'Space Mono', monospace", fontSize: 9, letterSpacing: 2, color: "#f87171", textTransform: "uppercase", display: "block", marginBottom: 8 }}>Tags <span style={{ color: "rgba(255,255,255,0.3)" }}>(comma separated)</span></label>
                      <input type="text" placeholder="e.g. All Hands, Priority, Capital" value={newEvent.tags} onChange={e => setNewEvent(p => ({ ...p, tags: e.target.value }))}
                        style={{ width: "100%", padding: "10px 14px", background: "rgba(255,255,255,0.04)", border: "1px solid rgba(248,113,113,0.25)", color: "#e8eaf6", fontFamily: "'Rajdhani', sans-serif", fontSize: 15, outline: "none", borderRadius: 2 }} />
                    </div>

                    {/* Reminder */}
                    <div style={{ marginBottom: 18 }}>
                      <label style={{ fontFamily: "'Space Mono', monospace", fontSize: 9, letterSpacing: 2, color: "#f87171", textTransform: "uppercase", display: "block", marginBottom: 8 }}>Reminder / Notification</label>
                      <select value={newEvent.reminder} onChange={e => setNewEvent(p => ({ ...p, reminder: e.target.value }))}
                        style={{ width: "100%", padding: "10px 14px", background: "#0a0610", border: "1px solid rgba(248,113,113,0.25)", color: "#e8eaf6", fontFamily: "'Rajdhani', sans-serif", fontSize: 15, outline: "none", borderRadius: 2 }}>
                        <option value="discord">Discord Notification</option>
                        <option value="email">Email</option>
                        <option value="both">Discord + Email</option>
                        <option value="none">No Reminder</option>
                      </select>
                    </div>

                    {/* Allow sharing toggle */}
                    <div style={{ marginBottom: 28, display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 16px", border: "1px solid rgba(248,113,113,0.18)", background: "rgba(248,113,113,0.04)" }}>
                      <div>
                        <div style={{ fontFamily: "'Space Mono', monospace", fontSize: 10, letterSpacing: 2, color: "#f87171", textTransform: "uppercase", marginBottom: 4 }}>Allow External Sharing</div>
                        <div style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 13, color: "rgba(232,234,246,0.4)" }}>Let members share this event outside of TSR</div>
                      </div>
                      <div onClick={() => setNewEvent(p => ({ ...p, allowSharing: !p.allowSharing }))}
                        style={{ width: 44, height: 24, borderRadius: 12, background: newEvent.allowSharing ? "#f87171" : "rgba(255,255,255,0.1)", border: `1px solid ${newEvent.allowSharing ? "#f87171" : "rgba(255,255,255,0.2)"}`, cursor: "pointer", position: "relative", transition: "all 0.3s ease", flexShrink: 0 }}>
                        <div style={{ position: "absolute", top: 3, left: newEvent.allowSharing ? 22 : 3, width: 16, height: 16, borderRadius: "50%", background: "#fff", transition: "left 0.3s ease" }} />
                      </div>
                    </div>

                    {/* Submit */}
                    <button onClick={() => {
                      if (!newEvent.title || !newEvent.date || !newEvent.time) return;
                      setEvents(prev => [...prev, {
                        ...newEvent,
                        id: Date.now(),
                        tags: newEvent.tags ? newEvent.tags.split(",").map(t => t.trim()).filter(Boolean) : [],
                      }]);
                      setNewEvent({ title: "", type: "Combat", date: "", time: "", description: "", image: "", allowSharing: false, reminder: "discord", tags: "" });
                      setShowEventForm(false);
                    }} style={{ width: "100%", padding: "14px", background: "transparent", border: "2px solid #f87171", color: "#f87171", fontFamily: "'Orbitron', sans-serif", fontSize: 13, fontWeight: 700, letterSpacing: 3, textTransform: "uppercase", cursor: "pointer", transition: "all 0.3s ease", clipPath: "polygon(10px 0%, 100% 0%, calc(100% - 10px) 100%, 0% 100%)" }}
                      onMouseEnter={e => { e.currentTarget.style.background = "#f87171"; e.currentTarget.style.color = "#05070f"; }}
                      onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#f87171"; }}>
                      Deploy Event →
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}

        </div>
      </section>

      {/* CTA */}
      <section style={{ position: "relative", zIndex: 1, padding: "100px 40px", textAlign: "center", overflow: "hidden" }}>
        <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)", width: 500, height: 500, background: "radial-gradient(circle, rgba(156,100,166,0.08) 0%, transparent 70%)", pointerEvents: "none" }} />
        <Reveal style={{ position: "relative", zIndex: 1 }}>
          <img src="https://starkeeper.industries/storage/team-images/01KJWM2B761W51KNBP5RCWYY3F.png" alt="TSR patch" style={{ width: 72, height: 72, objectFit: "contain", marginBottom: 28, opacity: 0.65 }} onError={(e) => { e.target.style.display = "none"; }} />
          <h2 style={{ fontFamily: "'Orbitron', sans-serif", fontWeight: 900, fontSize: "clamp(26px, 5vw, 56px)", color: "#e8eaf6", marginBottom: 16, lineHeight: 1.05 }}>
            Ready to Crew<br />The Sovereign<br />
            <span style={{ background: `linear-gradient(90deg, ${ACCENT}, #e040fb, ${ACCENT})`, backgroundSize: "200% auto", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", animation: "shimmer 4s linear infinite" }}>Revenant?</span>
          </h2>
          <p style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 18, color: "rgba(232,234,246,0.5)", maxWidth: 440, margin: "0 auto 44px", lineHeight: 1.7 }}>
            Crew the Idris. Train across disciplines. The mission evolves.
          </p>
          <div style={{ display: "flex", gap: 16, justifyContent: "center", flexWrap: "wrap" }}>
            <a href="https://discord.gg/aEPQ6Zfvhd" className="glow-btn">Join via Discord</a>
            <Link to="/hierarchy" style={{ display: "inline-block", padding: "12px 32px", border: "2px solid rgba(255,255,255,0.18)", color: "rgba(232,234,246,0.55)", fontFamily: "'Orbitron', sans-serif", fontSize: 12, fontWeight: 700, letterSpacing: 3, textTransform: "uppercase", transition: "all 0.3s ease", clipPath: "polygon(12px 0%, 100% 0%, calc(100% - 12px) 100%, 0% 100%)" }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = "rgba(255,255,255,0.45)"; e.currentTarget.style.color = "#e8eaf6"; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = "rgba(255,255,255,0.18)"; e.currentTarget.style.color = "rgba(232,234,246,0.55)"; }}>
              View All Teams
            </Link>
          </div>
        </Reveal>
      </section>

      {/* FOOTER */}
      <footer style={{ position: "relative", zIndex: 1, borderTop: "1px solid rgba(255,255,255,0.07)", padding: "40px", background: "rgba(0,0,0,0.4)" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 20 }}>
          <Link to="/" style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <img src="/images/logo.png" alt="Starkeeper" style={{ height: 28, width: "auto" }} onError={(e) => { e.target.style.display = "none"; }} />
            <span style={{ fontFamily: "'Orbitron', sans-serif", fontWeight: 700, fontSize: 12, letterSpacing: 2.5, color: "rgba(232,234,246,0.4)" }}>STARKEEPER INDUSTRIES</span>
          </Link>
          <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
            {NAV_LINKS.map((l) => (
              l.external
                ? <a key={l.label} href={l.href} style={{ fontFamily: "'Space Mono', monospace", fontSize: 9, letterSpacing: 2, color: "rgba(232,234,246,0.3)", textTransform: "uppercase", transition: "color 0.2s" }} onMouseEnter={e => e.target.style.color = ACCENT} onMouseLeave={e => e.target.style.color = "rgba(232,234,246,0.3)"}>{l.label}</a>
                : <Link key={l.label} to={l.href} style={{ fontFamily: "'Space Mono', monospace", fontSize: 9, letterSpacing: 2, color: "rgba(232,234,246,0.3)", textTransform: "uppercase", transition: "color 0.2s" }} onMouseEnter={e => e.target.style.color = ACCENT} onMouseLeave={e => e.target.style.color = "rgba(232,234,246,0.3)"}>{l.label}</Link>
            ))}
          </div>
        </div>
        <div style={{ maxWidth: 1100, margin: "20px auto 0", fontFamily: "'Space Mono', monospace", fontSize: 9, letterSpacing: 1.2, color: "rgba(232,234,246,0.18)", borderTop: "1px solid rgba(255,255,255,0.05)", paddingTop: 20, lineHeight: 1.8 }}>
          © 2026 Starkeeper Industries. All rights reserved. · Unofficial fansite. Star Citizen®, Squadron 42®, Roberts Space Industries®, and Cloud Imperium® are registered trademarks of Cloud Imperium Rights LLC. Not affiliated with Cloud Imperium or Roberts Space Industries.
        </div>
      </footer>
    </div>
  );
}